export const environment = {
  production: true,
  KEMPER_COM: 'https://www.kemper.com',
  KEMPER_LOGO: './assets/Kemper_Logo_small.png',
  FORGOT_ID: 'https://agenti0.kemper.com/pi/kidm/unsecure/userForgotUserId?TARGET=',
  FORGOT_PASSW: 'https://agenti0.kemper.com/pi/kidm/unsecure/userForgotPassword?TARGET=',
  RIGHT_PANEL_API: 'https://aiint.ekemper.com/RESTWCMContentPortalService/rest/RESTWCMService/query?wcmpath=/KemperAgent/Login/LoginPageContent&pt=PT_LOGIN',
  AM_INTERNAL_AWS_HOST: 'https://frigappi0.npd.aws.kemperi.com/',
  AM_INTERNAL_BHM_HOST: 'https://frigi0.kemperi.com/',
  AM_EXTERNAL_AWS_HOST: 'https://signini0.kemper.com/',
  AM_EXTERNAL_BHM_HOST: 'https://signinbi0.kemper.com/',
  DEFAULT_SERVICE: 'fr_authentication',
  DEFAULT_REALM: '/AEV',
  GOTO: '/openam/console',
  AM_HEADERS: {
    'Content-Type': 'application/json',
    'Accept-API-Version': 'resource=2.0, protocol=1.0',
    'Cache-Control': 'no-cache',
  }
};
